import React, { useState, useEffect } from 'react';

const AutoCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  
  // Same photos as the original grid
  const originalImages = [
    'mockup_1759930064602.jpg',
    'mockup_1759934124004.jpg',
    'mockup_1759934216198.jpg',
    'mockup_1759934372008.jpg',
    'mockup_1759945253889.jpg',
    'mockup_1760004261074.jpg',
    'mockup_1760004637940.jpg',
    'mockup_1760010487319.jpg',
    'mockup_1760018561810.jpg',
    'mockup_1760028013055.jpg',
    'mockup_1760034154486.jpg',
    'mockup_1760034477222.jpg',
    'mockup_1760034526389.jpg',
    'mockup_1760044459919.jpg',
    'mockup_1760103644198.jpg',
    'mockup_1759273714092.jpg',
    'mockup_1759273848405.jpg',
    'mockup_1759327975025.jpg',
    'mockup_1759838377570.jpg',
    'mockup_1759923044965.jpg'
  ];

  // Create enough duplicates for seamless infinite scrolling
  const infiniteImages = [...originalImages, ...originalImages, ...originalImages, ...originalImages];

  // Auto-slide every 3 seconds with infinite loop
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => {
        const nextIndex = prev + 1;
        // When we reach the end of original images, reset to 0 without transition
        if (nextIndex >= originalImages.length) {
          // Wait for the transition to complete before resetting
          setTimeout(() => {
            setIsTransitioning(false);
            setTimeout(() => {
              setCurrentIndex(0);
              // Re-enable transitions after reset
              setTimeout(() => {
                setIsTransitioning(true);
              }, 100);
            }, 0);
          }, 700); // Wait for the 700ms transition to complete
          return originalImages.length; // Show the duplicate first image
        }
        return nextIndex;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [originalImages.length]);

  // Calculate the actual display index for seamless looping
  const getDisplayIndex = (index) => {
    return index % originalImages.length;
  };

  // Calculate the center position for mobile (2nd image in 3-image layout)
  const getMobileCenterIndex = () => {
    return currentIndex + originalImages.length;
  };

  // Calculate the center position for desktop (3rd image in 5-image layout)
  const getDesktopCenterIndex = () => {
    return currentIndex + originalImages.length + 1;
  };

  return (
    <div className="relative w-full overflow-hidden py-32">
      {/* Mobile Carousel - 3 cards */}
      <div className="flex md:hidden justify-center items-center">
        <div 
          className={`flex ${isTransitioning ? 'transition-transform duration-700 ease-in-out' : ''}`}
          style={{
            transform: `translateX(${-currentIndex * 33.33}%)`
          }}
        >
          {infiniteImages.map((image, index) => {
            const displayIndex = getDisplayIndex(index);
            const isCenter = index === getMobileCenterIndex();
            
            return (
              <div 
                key={`mobile-${index}`}
                className="flex-shrink-0 w-[33.33%] aspect-[4/3] px-2"
              >
                <div 
                  className={`w-full h-full rounded-[32px] shadow-[0_40px_40px_rgba(0,0,0,0.25)] overflow-hidden border border-white/20 transition-all duration-500 ease-out ${
                    isCenter ? 'scale-110' : 'scale-100'
                  }`}
                >
                  <img 
                    src={`/mockupsConvertedResized/${originalImages[displayIndex]}`}
                    alt={`Mockup ${displayIndex + 1}`}
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Desktop Carousel - 5 cards */}
      <div className="hidden md:flex justify-center items-center">
        <div 
          className={`flex ${isTransitioning ? 'transition-transform duration-700 ease-in-out' : ''}`}
          style={{
            transform: `translateX(${-currentIndex * 20}%)`
          }}
        >
          {infiniteImages.map((image, index) => {
            const displayIndex = getDisplayIndex(index);
            const isCenter = index === getDesktopCenterIndex();
            
            return (
              <div 
                key={`desktop-${index}`}
                className="flex-shrink-0 w-[20%] aspect-[4/3] px-4"
              >
                <div 
                  className={`w-full h-full rounded-[32px] shadow-[0_40px_40px_rgba(0,0,0,0.25)] overflow-hidden border border-white/20 transition-all duration-500 ease-out ${
                    isCenter ? 'scale-110' : 'scale-100'
                  }`}
                >
                  <img 
                    src={`/mockupsConvertedResized/${originalImages[displayIndex]}`}
                    alt={`Mockup ${displayIndex + 1}`}
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AutoCarousel;